import { useCallback } from 'react';
// @mui
import { alpha, useTheme } from '@mui/material/styles';
import { Stack, Typography } from '@mui/material';
import Link from '@mui/material/Link';
// components
import SvgColor from 'src/components/svg-color';
// routes
import { RouterLink } from 'src/routes/components';
// global
import { ANDROID_URL } from 'src/config-global';
// locales
import { useLocales } from 'src/locales';
//
import AuthStatisticsTopStats from './auth-statistics-top-stats';
import AuthStatisticsLiveStats from './auth-statistics-live-stats';

// ----------------------------------------------------------------------

export default function AuthStatisticsContent() {
  const { t, currentLang, onChangeLang } = useLocales();
  const theme = useTheme();

  const isFa = currentLang?.value === 'fa';

  const handleChangeLang = useCallback(() => {
    if (isFa) onChangeLang('en');
    else onChangeLang('fa');
  }, [isFa, onChangeLang]);

  // ----------------------------------------------------------------------

  const renderAbout = (
    <Link
      component={RouterLink}
      variant="subtitle2"
      color="text.secondary"
      target="_blank"
      href="https://zharph.com"
      sx={{
        width: 'fit-content',
        transition: 'all ease 0.1s',
        '&:hover': {
          cursor: 'pointer',
          textDecoration: 'none',
          color: 'text.primary',
        },
      }}
    >
      {t('about_us')}
    </Link>
  );

  // ----------------------------------------------------------------------

  const renderLanguage = (
    <Typography
      variant="subtitle2"
      color="text.secondary"
      onClick={handleChangeLang}
      sx={{
        width: 'fit-content',
        fontFamily: isFa ? 'Roboto' : 'Vazir',
        transition: 'all ease 0.1s',
        '&:hover': {
          cursor: 'pointer',
          color: 'text.primary',
        },
      }}
    >
      {isFa ? 'English' : 'فارسی'}
    </Typography>
  );

  // ----------------------------------------------------------------------

  return (
    <Stack
      justifyContent="center"
      sx={{
        position: 'relative',
        zIndex: 5,
        height: 1,
        // maxWidth: 900,
        width: { xs: 0.9, sm: 0.75 },
        mx: 'auto',
      }}
    >
      {/* Badge */}
      {/* <Chip
          label=""
          color="primary"
          sx={{
            width: 'fit-content',
            mb: 3,
            px: 1,
            color: 'text.primary',
            backdropFilter: 'blur(12px)',
            backgroundColor: alpha(theme.palette.primary.main, 0.12),
            border: `1px solid ${alpha(theme.palette.primary.main, 0.24)}`,
          }}
        /> */}

      {/* Title */}
      <Typography
        variant="h2"
        sx={{
          mb: 2,
          fontWeight: 800,
          lineHeight: 1.2,
          maxWidth: 560,
          background:
            theme.palette.mode === 'light'
              ? `linear-gradient(
              135deg,
              ${alpha(theme.palette.info.main, 0.5)},
              ${alpha(theme.palette.primary.main, 0.8)}
            )`
              : `linear-gradient(
              135deg,
              ${theme.palette.common.white},
              ${alpha(theme.palette.primary.light, 0.9)}
            )`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }}
      >
        {t('zharph')}
      </Typography>

      <Typography
        sx={{
          mb: 5,
          // color: alpha(theme.palette.common.white, 0.72),
          color: 'text.secondary',
          maxWidth: 520,
          lineHeight: 1.8,
          fontSize: 16,
        }}
      >
        {t('zharph_description')}
      </Typography>

      {/* APK Download */}
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 3, mt: -3 }}>
        <Link
          href={ANDROID_URL}
          target="_blank"
          download
          underline="none"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.75,
            px: 1.5,
            py: 0.6,
            borderRadius: 2,
            border: `1px solid ${alpha(theme.palette.primary.main, 0.24)}`,
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
            color: 'text.secondary',
            fontSize: 13,
            fontWeight: 500,
            transition: 'all 0.2s',
            '&:hover': {
              backgroundColor: alpha(theme.palette.primary.main, 0.16),
              color: 'text.primary',
              cursor: 'pointer',
            },
          }}
        >
          <SvgColor
            src="/assets/icons/global/material-symbols--android.svg"
            width={16}
            sx={{ color: 'success.main' }}
          />
          {t('download_apk')}
        </Link>
      </Stack>

      {/* Top Stats */}
      <AuthStatisticsTopStats />

      {/* Live Stats */}
      <AuthStatisticsLiveStats />

      <Stack direction="row" alignItems="center" spacing={1.25} sx={{ mt: 4, alignSelf: 'center' }}>
        {renderAbout}
        <Typography variant="subtitle2" color="text.disabled">
          •
        </Typography>
        {renderLanguage}
      </Stack>
    </Stack>
  );
}
